import { connect } from 'react-redux';
import UploadDocuments from '../../../components/UploadDocuments/UploadDocuments';

import {
  uploadDocsRequest,
  uploadDocsReset
} from '@xanadu/ui-shared/modules/uploadDocs/actions';

import {
  displayModal
} from '@xanadu/ui-shared/modules/modal/actions';
import { depositRequest } from '@xanadu/ui-shared/modules/user/actions';

const mapDispatchToProps = {
  uploadDocsRequest,
  uploadDocsReset,
  displayModal,
  depositRequest,
};

function mapStateToProps(state) {
  return {
    loading: state.getIn(['uploadDocs', 'loading']),
    error: state.getIn(['uploadDocs', 'error']),
    POIStatus: state.getIn(['user', 'proofOfIdentityStatus']),
    POAStatus: state.getIn(['user', 'proofOfAddressStatus']),
    countryId: state.getIn(['user', 'countryId']),
    jobTitle: state.getIn(['user', 'jobTitle']),
    salaryRange: state.getIn(['user', 'salaryRange']),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadDocuments);
